const Shareds = {
    legendDefault: 'Lista com os registros de {PAGE} cadastradas',
    pendenteDesenvolvimento: 'US pendente de desenvolvimento.',
    form: {
        actions: {
            create: 'Criar',
            update: 'Alterar',
            view: 'Visualizar',
        },
        confirmDelete: 'Tem certeza que deseja prosseguir com a exclusão desse registro?',
        successCancelar: 'Registro cancelado com sucesso!',
        successCreate: 'Registro criado com sucesso!',
        successUpdate: 'Registro alterado com sucesso!',
        successStateUpdate: 'Status alterado com sucesso',
        errorStateUpdate: 'Não foi possível alterar o status do registro selecionado.',
        successDelete: 'Registro removido com sucesso',
        errorDelete: 'Não foi possível remover o registro selecionado.',
        dontSaveData: 'As Informações inseridas não foram salvas, deseja abandonar a Tela?',
        switchState: 'Tem certeza que deseja prosseguir com a {LABEL} desse registro?',
        validationPending:
            'Não foi possível finalizar o formulário, pois existem campos obrigatórios que não foram preenchidos.',
    },
    login: {
        sessaoExpirada: 'Sua sessão expirou! Por favor Logue novamente',
    },
    request: {
        error403: {
            title: 'Não autorizado',
        },
        error400: {
            title: 'Validação',
        },
    },
    export: {
        success: 'Exportação realizada com sucesso',
        error: 'Não foi possível realizar a exportação',
    },
    naoDefinido: 'Não definido',
};

export default Shareds;
